import type { HTMLAttributes } from 'react';
import React from 'react';
import type {Props as scrollProps} from 'react-infinite-scroll-component';
import InfiniteScroll from 'react-infinite-scroll-component';

export const InfiniteScrollComponent = ({
  children,
  ...rest
}: InfiniteScrollProps.Props): React.ReactElement => (
  <InfiniteScroll
    {...rest}
  >
    <div className='scroll-container'>
      <div className='row-container'>{children}</div>
    </div>
  </InfiniteScroll>
);

export namespace InfiniteScrollProps {
  export type Props = HTMLAttributes<HTMLDivElement> & scrollProps & {
      children: React.ReactNode;
    };
}
